export const CALCULATORS = [
  {
    slug: 'retirement-expense-estimator',
    title: 'Retirement Expense Estimator',
    description: 'Model your annual retirement expenses with key assumptions.',
    icon: 'fas fa-wallet',
    route_path: '/calculator/retirement-expense-estimator',
    group: 'retirement',
  },
  {
    slug: 'retirement-savings-goal',
    title: 'Retirement Savings Goal',
    description: 'Estimate the corpus needed to fund retirement expenses.',
    icon: 'fas fa-piggy-bank',
    route_path: '/calculator/retirement-savings-goal',
    group: 'retirement',
  },
  {
    slug: 'savings-required',
    title: 'Monthly Savings Required',
    description: 'Calculate monthly savings needed to reach your target corpus.',
    icon: 'fas fa-bullseye',
    route_path: '/calculator/savings-required',
    group: 'retirement',
  },
  {
    slug: 'start-early-impact',
    title: 'The Power of Starting Early',
    description: 'See how starting age changes long-term outcomes.',
    icon: 'fas fa-hourglass-start',
    route_path: '/calculator/start-early-impact',
    group: 'retirement',
  },
  {
    slug: 'accumulated-corpus',
    title: 'Project Total Wealth',
    description: 'Project total wealth from current corpus and monthly savings.',
    icon: 'fas fa-chart-line',
    route_path: '/calculator/accumulated-corpus',
    group: 'retirement',
  },
  {
    slug: 'sip-historical-analysis',
    title: 'SIP Returns Calculator',
    description: 'See how your monthly SIP would have grown on Nifty and other indices.',
    icon: 'fas fa-seedling',
    route_path: '/calculator/sip-historical-analysis',
    group: 'investment',
  },
  {
    slug: 'nps-vs-ups',
    title: 'NPS vs UPS',
    description: 'Compare how long your NPS corpus may last versus UPS payouts.',
    icon: 'fas fa-scale-balanced',
    route_path: '/calculator/nps-vs-ups',
    group: 'retirement',
  },
  {
    slug: 'home-loan-affordability',
    title: 'Home Loan Affordability Stress-Tester',
    description:
      'Stress-test how future surplus compares with a chosen home-loan EMI.',
    icon: 'fas fa-house-chimney',
    route_path: '/calculator/home-loan-affordability',
    group: 'loans',
  },
  {
    slug: 'home-loan-affordability-guided',
    title: 'Home Loan Affordability (Guided)',
    description:
      'Same stress-test, one clean question page at a time—less clutter, same math.',
    icon: 'fas fa-route',
    route_path: '/calculator/home-loan-affordability-guided',
    group: 'loans',
  },
  {
    slug: 'emi-calculator',
    title: 'EMI Calculator',
    description: 'Estimate your monthly loan EMI from amount, rate, and tenure.',
    icon: 'fas fa-file-invoice-dollar',
    route_path: '/calculator/emi-calculator',
    group: 'loans',
  },
  {
    slug: 'where-your-emi-really-goes',
    title: 'Where Your EMI Really Goes',
    description:
      'See how each year’s EMI splits into interest vs principal—and why early years barely cut your loan.',
    icon: 'fas fa-chart-pie',
    route_path: '/calculator/where-your-emi-really-goes',
    group: 'loans',
  },
  {
    slug: 'loan-amount-calculator',
    title: 'Loan Amount Calculator',
    description: 'Estimate the loan amount supported by a given EMI, rate, and tenure.',
    icon: 'fas fa-hand-holding-dollar',
    route_path: '/calculator/loan-amount-calculator',
    group: 'loans',
  },
  {
    slug: 'interest-rate-impact',
    title: 'Interest Rate Impact Calculator',
    description:
      'See how a rate change affects your EMI or loan tenure—and when tenure extension is not enough.',
    icon: 'fas fa-percent',
    route_path: '/calculator/interest-rate-impact',
    group: 'loans',
  },
  {
    slug: 'pre-emi-calculator',
    title: 'Pre-EMI Cost Calculator',
    description: 'Compare extra interest from pre-EMI versus full EMI from day one.',
    icon: 'fas fa-triangle-exclamation',
    route_path: '/calculator/pre-emi-calculator',
    group: 'loans',
  },
  {
    slug: 'tenure-interest-calculator',
    title: 'Tenure Interest Calculator',
    description:
      'See how changing loan tenure changes the total interest you pay over the full term.',
    icon: 'fas fa-hourglass-half',
    route_path: '/calculator/tenure-interest-calculator',
    group: 'loans',
  },
  {
    slug: 'part-prepayment-calculator',
    title: 'Part-Prepayment Tenure Calculator',
    description:
      'See how many months a part-prepayment can cut from your home loan when EMI stays the same.',
    icon: 'fas fa-hand-holding-usd',
    route_path: '/calculator/part-prepayment-calculator',
    group: 'loans',
  },
];

export const CALCULATOR_GROUPS = [
  {
    id: 'retirement',
    title: 'Retirement Planning',
    subtitle: 'Estimate expenses, corpus targets, and the power of starting early',
  },
  {
    id: 'loans',
    title: 'Loan',
    subtitle: 'Affordability, EMI split, rate changes, and pre-EMI cost comparisons',
  },
  {
    id: 'investment',
    title: 'Investment',
    subtitle: 'Tools for mutual funds and portfolio decisions—coming soon',
  },
];

export function groupCalculators(calculators = CALCULATORS) {
  return CALCULATOR_GROUPS.map((group) => ({
    ...group,
    tools: calculators.filter((tool) => tool.group === group.id),
  }));
}

export default function useCalculators() {
  return {
    calculators: CALCULATORS,
    groups: groupCalculators(CALCULATORS),
  };
}
